import type { FaireProductEntity } from "../../entity_types/product";

export const p_8cema7cqch: FaireProductEntity = {
  token: "p_8cema7cqch",
  type: "product",
  name: "The Go-To Tee (Wholesale 2-2-1)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/c90c84d29266ec2c8748d190d0fe82c426ecb9f6d8fe33faea22bea8af61291c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c8317f8bc847a8712f392e22e373c78ddc628a873186882febe1d457e1e51ed.jpeg",
    "https://cdn.faire.com/fastly/e101c3d36475351c8ce4619a5a61bb2555ecb00ec15d7ca85c5327515d39180e.jpeg",
    "https://cdn.faire.com/fastly/29a28a23865a27615c2ad717a7626d2b057da62dac1f09d61f104a40d8b489b5.jpeg",
    "https://cdn.faire.com/fastly/b7b88aa33007694eaca27c55f95d2dd13952207c1963b28e506b25a4656f09ba.jpeg",
    "https://cdn.faire.com/fastly/7c862f08f3b993cdd02983f77207f1e19fcc98294e0eeba3d317948370f34d86.jpeg",
    "https://cdn.faire.com/fastly/08d6db5169ce07b13b3fa1d72a7f7ec3b236090b986d0f5b19cbc26bf8cb6e79.jpeg",
    "https://cdn.faire.com/fastly/233acc7fe47e09c1a79fa59bf0b709e5f701e425a7be06f0ce0fd393b9bd16f1.jpeg",
    "https://cdn.faire.com/fastly/4ea1ae19a817198f329cca0fe904c77245606650d48f2727cb8aafe854290789.jpeg",
    "https://cdn.faire.com/fastly/8d72512c61299c25f23dd09f746686140bd39a80e8cd0a5b5f9e66c8c9ea046e.jpeg",
    "https://cdn.faire.com/fastly/8b8ec7766f1032e3407d132e6bbb401b09c866df6111868b679bd2ff984d6b60.jpeg",
    "https://cdn.faire.com/fastly/b76161e35037b7304861ec239b31808cca0bce1da463c39ad32320747d7ab0ef.jpeg",
    "https://cdn.faire.com/fastly/d12a136f91ec45558f82b6a5bf9d825d71b94d423d57455c72f732954d507d9a.jpeg",
  ],
  priceDollars: 145,
  description:
    'Why We Made This?\n\nYour new wardrobe staple that lives up to its name. The Go-To Tee features the same fit as our iconic Little Boy Tee and a longer length for a timeless feel. Made from the same premium cotton jersey, it’s easy to style and adds an elevated touch to any look.\n\nWe used the softest local 100% cotton premium jersey. Garment washed and dyed each tee for a beautiful natural worn-in look. Fabric and garments are made in sunny Los Angeles with all our love! \n\nMade in Los Angeles, USA \n\nPlease note: The dyeing and washing process gives each garment unique character. Please allow for slight color and fit variation for each garment. \nContents: 100% Cotton premium jersey \n\nCare Instructions: Due to the nature of pigment dye, loose pigments may remain on the surface of the garments. -Do not spot clean -Washing these garments only with like colors and in cold water -Hang Dry \n\n\nApproximate Measurements: Length: 23"(S), 23 1/2"(M), 24"(L) Chest : 17 1/2"(S), 18 1/2"(M), 19 1/2"(L) Model is 5\'6", 110lbs and wearing a size Small\n\n\nMSRP: $59 USD \n\n',
  tags: [],
  msrpDollars: 295,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:02.676Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
